module.exports = __webpack_public_path__ + "7880265f10bfe1a09dcf0912409f761a.pdf";